import React, { useCallback, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { FORMAT_META } from "./eventUi";

const STATUSES = [["pending", "Pending"], ["changes_requested", "Changes Requested"], ["approved", "Approved"], ["declined", "Declined"]];

function Decide({ ev, onDone }) {
  const [comment, setComment] = useState("");
  const go = async (action) => {
    try { await api.post(`/events/${ev.id}/approval`, { action, comment }); toast.success("Saved"); onDone(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="space-y-1.5 min-w-[220px]">
      <Textarea rows={2} placeholder="Comment for the Agent (required for Request Changes)" value={comment} onChange={(e) => setComment(e.target.value)} data-testid={`approval-comment-${ev.id}`} />
      <div className="flex gap-1">
        <Button size="sm" onClick={() => go("approve")} className="bg-emerald-600 hover:bg-emerald-700" data-testid={`approval-approve-${ev.id}`}>Approve</Button>
        <Button size="sm" variant="outline" onClick={() => go("request_changes")} data-testid={`approval-changes-${ev.id}`}>Request Changes</Button>
        <Button size="sm" variant="outline" className="text-rose-700" onClick={() => go("decline")} data-testid={`approval-decline-${ev.id}`}>Decline</Button>
      </div>
    </div>);
}

export function ApprovalQueue({ focus }) {
  const [status, setStatus] = useState("pending");
  const [items, setItems] = useState(null);
  const load = useCallback(() => { api.get("/events/approvals", { params: { status } }).then((r) => setItems(r.data.items)).catch((e) => toast.error(apiError(e))); }, [status]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-3" data-testid="approval-queue">
      <div className="flex gap-2">{STATUSES.map(([k, l]) => (
        <button key={k} onClick={() => setStatus(k)} data-testid={`approval-status-${k}`} className={`px-3 py-1 rounded-full text-xs border ${status === k ? "bg-[#006090] text-white border-[#006090]" : "bg-white text-slate-600"}`}>{l}</button>))}</div>
      {items && items.length === 0 ? <p className="text-sm text-slate-500 p-8 text-center border border-dashed rounded-xl" data-testid="approval-empty">No events here.</p> :
        <div className="overflow-x-auto"><table className="w-full text-sm"><thead className="text-xs text-slate-500 bg-slate-50"><tr>
          {["Event", "Creator", "Group", "Date / Time", "Location / Online", "Audience", "Submitted", "Status", status === "pending" ? "Actions" : ""].map((h, i) => <th key={i} className="text-left p-2">{h}</th>)}</tr></thead>
          <tbody>{(items || []).map((e) => (
            <tr key={e.id} className={`border-t align-top ${focus === e.id ? "bg-amber-50" : ""}`} data-testid={`approval-row-${e.id}`}>
              <td className="p-2 font-medium">{e.title}<p className="text-xs text-slate-400">{e.event_type}</p>{e.short_description && <p className="text-xs text-slate-500 mt-1 max-w-xs">{e.short_description}</p>}</td>
              <td className="p-2">{e.created_by_name}</td><td className="p-2">{(e.group_names || []).join(", ")}</td>
              <td className="p-2 whitespace-nowrap">{e.date} {e.start_time}–{e.end_time}<p className="text-xs text-slate-400">{e.timezone}</p></td>
              <td className="p-2">{FORMAT_META[e.format]?.label}{e.venue_name ? ` · ${e.venue_name}` : ""}</td>
              <td className="p-2">Agents</td><td className="p-2 whitespace-nowrap">{(e.submitted_at || "").slice(0, 10)}</td>
              <td className="p-2" data-testid={`approval-label-${e.id}`}>{e.visibility_label}{e.approval_comment && <p className="text-xs text-slate-500">“{e.approval_comment}”</p>}</td>
              <td className="p-2">{status === "pending" && <Decide ev={e} onDone={load} />}</td>
            </tr>))}</tbody></table></div>}
    </div>);
}
